import React from 'react'
import { Box } from '@fundamentals'
import { Card } from '@common/material'
import { localizedStrings } from '@core/strings'
import { IUser } from '@core/entities/user'
import { UserCardHeader } from './components/UserCardHeader'
import { UserCardBanner } from './components/UserCardBanner'
import { LastBriefedRow } from './components/LastBriefedRow'

export type ExternalUser = Pick<IUser, 'firstName' | 'lastName' | 'company'>

type ExternalUserProfileCardProps = {
  user: ExternalUser
  lastBriefedOn?: string
}

export const ExternalUserProfileCard: React.FC<
  ExternalUserProfileCardProps
> = ({ user, lastBriefedOn }) => (
  <Card
    sx={{
      minWidth: 280,
      width: 'max-content',
      overflow: 'hidden',
      boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
    }}
  >
    <UserCardBanner>{localizedStrings.noSiteAssistAccount}</UserCardBanner>
    <UserCardHeader user={user} name={`${user.firstName} ${user.lastName}`} />
    {lastBriefedOn && (
      <Box px={1.5} pb={1.5}>
        <LastBriefedRow lastBriefedOn={lastBriefedOn} />
      </Box>
    )}
  </Card>
)
